import type { RxJsonSchema } from 'rxdb';
import type { WorkPackageFiles } from './workPackageFiles.types';

export const workPackageFilesSchema: RxJsonSchema<WorkPackageFiles> = {
  type: 'object',
  version: 0,
  description: 'describes work package files',
  primaryKey: 'fileId',
  properties: {
    fileId: { type: 'string', maxLength: 36 },
    workPackageId: { type: ['string', 'null'] },
    fileName: { type: ['string', 'null'] },
    filePath: { type: ['string', 'null'] },
    inspectorId: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
  },
};
